import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTelegram,
    faYoutube,
    faTwitter,
    faInstagram,
} from '@fortawesome/free-brands-svg-icons';
import styled, { keyframes } from 'styled-components'; // Import styled-components
import { fadeIn, rotateInDownLeft, rotateInDownRight, slideInDown } from 'react-animations'; // Import the fadeIn animation
import { t } from 'ttag';
import './css/Project.css'; // Создайте этот CSS файл
import { mixpanel } from './mp.js';


const RotateInDownLeftDiv = styled.div`animation: 0.7s ${keyframes`${rotateInDownLeft}`} ease-out;`;
const RotateInDownRightDiv = styled.div`animation: 0.7s ${keyframes`${rotateInDownRight}`} ease-out;`;
const SlideInDownDiv = styled.div`animation: 0.9s ${keyframes`${slideInDown}`} ease-out;`;


function Project() {

    return (

        <div style={{ width: "100%" }}>
            <SlideInDownDiv>
                <div className="project-blok-button" >
                    <a className="project-button" target="_blank" href="https://miniapp.bitbook.trade/pdf/BitBook_en.pdf" onClick={() => mixpanel.track('project-get-presentation-pdf')}>
                        {t`Presentation`}
                    </a>
                </div>
            </SlideInDownDiv>
            <div className="social-links">
                <RotateInDownLeftDiv>
                    <a
                        href="https://t.me/bitbook_channel"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ color: "#2AABEE" }}
                        onClick={() => mixpanel.track('project-to-telegram-chanel')}
                    >

                        <FontAwesomeIcon icon={faTelegram} />
                    </a>
                </RotateInDownLeftDiv>
                <RotateInDownLeftDiv>
                    <a
                        href="https://t.me/bitbook_chat"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ color: "#2AABEE" }}
                        onClick={() => mixpanel.track('project-to-telegram-chat')}
                   >
                        <FontAwesomeIcon icon={faTelegram} />
                    </a>
                </RotateInDownLeftDiv>
                <SlideInDownDiv>
                    <a
                        href="https://www.youtube.com/@BitBook_trade"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ color: "#1DA1F2" }}
                        onClick={() => mixpanel.track('project-to-youtube')}
                    >
                        <FontAwesomeIcon icon={faYoutube} />
                    </a>
                </SlideInDownDiv>
                <RotateInDownRightDiv>
                    <a
                        href="https://x.com/bitbook_trade?s=21&t=NDJ1a5T6zmD1XF8TqOSc_A"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ color: "#E4405F" }}
                        onClick={() => mixpanel.track('project-to-twitter')}
                    >
                        <FontAwesomeIcon icon={faTwitter} />
                    </a>
                </RotateInDownRightDiv>
                <RotateInDownRightDiv>
                    <a
                        href="https://www.instagram.com/bitbook.trade?igsh=bmc4OHExbTMyZTZ5&utm_source=qr"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ color: "#FF0000" }}
                        onClick={() => mixpanel.track('project-to-instagram')}
                    >
                        <FontAwesomeIcon icon={faInstagram} />
                    </a>
                </RotateInDownRightDiv>
            </div>
            <div className="project-blok">
                <div className="project-blok-sub">
                    {t`BitBook is a next-generation social platform for enthusiasts, bringing together a wide range of opportunities in one place.`}
                </div>
                <div className="project-blok-sub">
                    {t`The mission of BitBook is to democratize the financial space by making knowledge, tools, and earning opportunities accessible to everyone — regardless of experience or capital.`}
                </div>
                <div className="project-blok-sub">
                    {t`BitBook’s goal is to become the leading social platform in the world of finance, uniting traders, investors, bloggers, and enthusiasts into a single ecosystem.`}
                </div>
                <div className="project-blok-sub">
                    {t`BitBook strives to bridge the gap between professionals and the broader audience. The platform promotes the values of transparency and trust.`}
                </div>
                <div className="project-blok-sub">
                    {t`BitBook is shaping a new generation of leaders by creating an environment where every user can unlock their potential — as a trader, analyst, creator, or entrepreneur.`}
                </div>
                <div className="project-blok-sub">
                    {t`The long-term vision is to become a bridge between traditional finance and the decentralized economy, offering a convenient and user-friendly path into Web3 for millions of people around the world.`}              </div>
            </div>
        </div>
    );
}

export { Project };